import { BaseModel } from '@shared/base/Base.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';

export class UserPasswordModel extends BaseModel implements IRestModel {
    public password: string = null;
    public changed: boolean = null;
    public readonly isIRestModel = true;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'SHR-UserPasswordModel');
    }

    public toRestApiModel() {
        return {
            Password: this.password,
        };
    }
}
